import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { PRODUCTS, PRODUCT_CATEGORIES } from "../data/site";

const ProductsPage = () => (
  <main className="pt-40 pb-28 min-h-screen" data-testid="products-page">
    <div className="max-w-6xl mx-auto px-6">
      <Reveal>
        <p className="font-mono text-xs tracking-[0.3em] uppercase text-smipl-orange mb-4">Our Products</p>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.05]">
          AI Systems. Built for<br /><span className="text-smipl-orange">Real Operations.</span>
        </h1>
        <p className="mt-6 text-base md:text-lg text-slate-400 max-w-2xl leading-relaxed">
          Eighteen production-grade AI products across video analytics, industrial operations,
          document intelligence, healthcare and generative AI — deployable on your infrastructure.
        </p>
      </Reveal>

      {PRODUCT_CATEGORIES.map((cat, ci) => {
        const items = PRODUCTS.filter((p) => p.cat === ci);
        if (!items.length) return null;
        return (
          <section key={cat} className="mt-20" data-testid={`product-cat-${ci}`}>
            <Reveal>
              <p className="font-mono text-[11px] tracking-[0.3em] uppercase text-smipl-orange mb-8 flex items-center gap-4">
                {String(ci + 1).padStart(2, "0")} <span className="text-white/30">/</span> {cat}
                <span className="flex-1 h-px bg-white/8" />
              </p>
            </Reveal>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {items.map((p, i) => (
                <Reveal key={p.id} delay={(i % 3) * 0.06}>
                  <Link
                    to={`/products/${p.id}`}
                    data-testid={`product-card-${p.id}`}
                    className="tracing-border group h-full rounded-2xl border border-white/8 bg-navy-deep/60 p-7 block transition-all duration-300 hover:-translate-y-1.5 hover:border-smipl-orange/40"
                  >
                    <div className="flex items-start justify-between gap-3">
                      <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-smipl-orange/10 border border-smipl-orange/25 text-smipl-orange group-hover:bg-smipl-orange group-hover:text-white transition-all duration-300">
                        <p.icon size={19} />
                      </div>
                      <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-smipl-orange/40 text-smipl-orange transition-all duration-300 group-hover:bg-smipl-orange group-hover:text-white group-hover:scale-110">
                        <ArrowUpRight size={13} />
                      </span>
                    </div>
                    <h3 className="mt-5 font-display text-base md:text-lg font-bold leading-snug">{p.name}</h3>
                    <p className="mt-2 text-sm text-slate-500 leading-relaxed">{p.blurb}</p>
                    <p className="mt-4 font-mono text-[10px] tracking-[0.25em] uppercase text-smipl-orange/60 group-hover:text-smipl-orange transition-colors">
                      View product
                    </p>
                  </Link>
                </Reveal>
              ))}
            </div>
          </section>
        );
      })}
    </div>
  </main>
);

export default ProductsPage;
